import { useSpinner } from "@components/SpinnerContext";
import { CardText } from "@models/card-text.model";
import accomodationService from "@services/accomodation.service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page404 from '@pages/NotFoundPage';
import titleService from "@services/title.service";
import PageHeader from "@components/PageHeader";
import { sanitizeHtml } from "@utils/sharedFunctions";

const TextPage = () => {
  const { showSpinner, hideSpinner, loading } = useSpinner();
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const location = useLocation();
  const [cardText, setCardText] = useState<CardText | undefined>(undefined);
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    async function getHomePageData(id: number, qrCodeId: string, textId: number) {
      try {
        showSpinner();
        const title = await titleService.getTitle(qrCodeId, id);
        setPageTitle(title);

        const response = await accomodationService.getCardText(id);
        setCardText(response);

      } catch (error) {
        setIsPageNotFound(true);
        console.error(error);
      } finally {
        hideSpinner();
      }
    }

    const parts = location.pathname.split("/").filter(Boolean);
    const qrCodeId = parts[0];
    const id = parts[parts.length - 2];
    const textId = parts[parts.length - 1];
    getHomePageData(parseInt(id), qrCodeId, parseInt(textId));

  }, [location.pathname]);

  const sanitizedHtml = cardText?.textDetail
    ? sanitizeHtml(cardText.textDetail).replace(/&nbsp;/g, ' ')
    : '';

  return (
    <div className="mx-3 text-white">
      <div className="sticky-top sticky-header border-bottom border-light">
        <PageHeader pageTitle={pageTitle} flagSearch={false} flag={false} />
      </div>

      {isPageNotFound ? (
        <Page404 />
      ) : (
        !loading && (
          <div>
            {cardText?.photo && (
              <div className="d-flex justify-content-center mt-3">
                <img
                  src={`data:image/png;base64,${cardText?.photo}`}
                  alt="immagine"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "60vh",
                    width: "auto",
                    height: "auto",
                    objectFit: "contain",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
            <div
              className="mt-4 mb-0 pb-4"
              style={{
                maxWidth: '100%',
                overflowX: 'hidden',
                wordBreak: 'break-word',
                overflowWrap: 'break-word',
              }}
              dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
            />
          </div>
        )
      )}
    </div>
  );
};

export default TextPage;
